import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const HeaderTab = styled(Box)(`
	display: flex;
	align-items: center;
	background: #F7F7F9;
	padding: 6px 10px;
	width: 100%;
	& .tab {
		padding: 5px 10px;
		font-size: 14px;
		font-weight: 400; // 300;
		margin-right: 2px;
		cursor: pointer;
		position:relative;

		&.active {
			background: #fff;
			font-weight: 600; // 500;
		}
	}

  .themeV2 & {
	background: none;
	padding: 0px 0px;
    & .tab {
      padding: 5px 10px 5px 0px;
      border-bottom: 2px solid transparent;
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
      cursor: pointer;
      position: relative;

      &:hover {
        color: #095BBD;
      }

      &.active {
        color: #095BBD;
        border-bottom: 2px solid #095BBD;
      }
    }
  }
`)

export const HeaderWrap = styled(Box)(`
	display: flex;
	align-items: center;
	width: 100%;
`)

export const Tab = styled(Box)(() => ({
  cursor: 'pointer',
}))

export const TabLabel = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})(({ active }) => ({
  borderBottom: '2px solid',
  borderColor: active ? '#095BBD' : 'transparent',
  color: active ? '#095BBD' : 'inherit',
  display: 'flex',
  alignItems: 'center',
}))

